import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Zap, X } from "lucide-react";
import { api } from "@/lib/api";
import { useCountdown, pad } from "@/components/deals";

const Inner = ({ deal, pct, onClose }) => {
  const { d, h, m, s, done } = useCountdown(deal.deal_ends_at);
  if (done) return null;
  return (
    <div className="relative bg-gradient-to-r from-rose-700 via-rose-600 to-amber-600 text-white" data-testid="deal-banner">
      <Link
        to="/offres"
        className="flex items-center justify-center gap-2 px-10 py-2 text-center text-xs font-semibold transition-opacity hover:opacity-90 sm:text-sm"
        data-testid="deal-banner-link"
      >
        <Zap className="h-4 w-4 shrink-0 text-amber-200" />
        <span className="truncate">
          Offre du jour : {deal.name}
          {pct > 0 ? ` −${pct}%` : ""} — fin dans
        </span>
        <span className="font-num shrink-0 rounded bg-black/20 px-1.5 py-0.5">
          {d > 0 ? `${d}j ` : ""}
          {pad(h)}:{pad(m)}:{pad(s)}
        </span>
      </Link>
      <button
        type="button"
        onClick={onClose}
        aria-label="Fermer la bannière"
        className="absolute right-2 top-1/2 grid h-6 w-6 -translate-y-1/2 place-items-center rounded-full hover:bg-black/20"
        data-testid="deal-banner-close"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
};

export const DealBanner = () => {
  const [deal, setDeal] = useState(null);
  const [closed, setClosed] = useState(() => sessionStorage.getItem("es_deal_banner_closed") === "1");

  useEffect(() => {
    if (closed) return;
    api
      .get("/products", { params: { deal: true, sort: "deal_ending", limit: 20 } })
      .then((r) => {
        const now = Date.now();
        const list = (r.data.items || []).filter((p) => new Date(p.deal_ends_at).getTime() > now);
        if (!list.length) return;
        const disc = (p) => (p.compare_price > p.price ? 1 - p.price / p.compare_price : 0);
        setDeal(list.reduce((a, b) => (disc(b) > disc(a) ? b : a)));
      })
      .catch(() => {});
  }, [closed]);

  if (!deal || closed) return null;
  const pct = deal.compare_price > deal.price ? Math.round((1 - deal.price / deal.compare_price) * 100) : 0;
  return (
    <Inner
      deal={deal}
      pct={pct}
      onClose={() => {
        sessionStorage.setItem("es_deal_banner_closed", "1");
        setClosed(true);
      }}
    />
  );
};
